import Stack, { StackProps } from "@mui/material/Stack";
import { GameDisplayHeight } from "./Constants";

const GameDisplayGap = 2;

export default function GameDisplayStack({
  gap = 2,
  displayCount,
  ...props
}: StackProps & {
  displayCount: number;
}) {
  const GameStackSx = {
    maxHeight: `calc(${displayCount * GameDisplayHeight}px + ${
      (GameDisplayGap / 2) * (displayCount - 1)
    }em)`,
    overflowY: "auto",
  };
  return <Stack gap={gap} sx={GameStackSx} {...props} />;
}
